import { Box, Checkbox as NBCheckbox, themeTools } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';
import styleShape from 'react-style-proptype';
import { FormControl } from '~/native-ui/FormControl';
import { Pressable } from '~/native-ui/Pressable';
import { extractFlexProps, extractSpacingProps } from '~/native-ui/utils';
import { WithColorMode } from '../hoc';
import { Icon } from '../Icon';

/**
 * 
 * @typedef {import('./types').CheckboxProps} CheckboxProps
 * @typedef {import('native-base').ICheckboxProps} ICheckboxProps
 * @param {React.ComponentType<ICheckboxProps>} Check
 * @returns {React.ComponentType<CheckboxProps>}
 */
const factory = (Check) => {
    class Checkbox extends React.Component {
        static propTypes = {
            checked: PropTypes.bool,
            children: PropTypes.node,
            className: PropTypes.string,
            disabled: PropTypes.bool,
            readonly: PropTypes.bool,
            label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
            error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
            name: PropTypes.string,
            onChange: PropTypes.func,
            onMouseEnter: PropTypes.func,
            onMouseLeave: PropTypes.func,
            style: styleShape,
            theme: PropTypes.shape({
                disabled: PropTypes.string,
                field: PropTypes.string,
                input: PropTypes.string,
                ripple: PropTypes.string,
            }),
        };

        static defaultProps = {
            checked: false,
            className: '',
            disabled: false,
        };

        handleToggle = (isChecked, event) => {
            if (!this.props.disabled && this.props.onChange) {
                this.props.onChange(!this.props.checked, event);
            }
        };

        renderCheckboxLabel() {
            const { label, tooltip, invalid, error } = this.props;
            const hasErrored = invalid || error;

            if (!label && !error) return null;
            return <FormControl.Label label={error ?? label} color={hasErrored ? 'danger.900' : undefined} tooltip={tooltip}></FormControl.Label>;
        }

        renderCheckboxDescription() {
            const { children, disabled } = this.props;
            return children ? (
                <Box flex="1" ml="1" _text={disabled ? {color: themeTools.mode(`muted.400`, `muted.700`)(this.props)} : undefined}>
                    {children}
                </Box>
            ) : null;
        }
        render() {
            const { checked, disabled, readonly, invalid, checkboxProps: cbProps, style } = this.props;


            const checkboxProps = {
                color: disabled || readonly ? themeTools.mode(`muted.100`, `muted.800`)(this.props) : invalid ? 'error.600' : checked ? "primary.600" : "muted.300",
                size: 7,
                ...cbProps,
                // value: this.props.value ?? true,
                alignItems: 'center',
                isInvalid: invalid || false,
                isChecked: checked || false,
                isDisabled: disabled || false,
                _interactionBox: readonly || disabled ? { display: 'none' } : undefined,
                _icon: readonly ? { color: 'primary.500' } : undefined,
                style: [style, {userSelect: 'none', left: "-2px", position: "relative"}],
                type: !checked ? "check-box-outline-blank" : "check-box",
                alignSelf: "flex-start"
            };

            const props = {
                py: '10px',
                maxW: this.props.children ? null : '50px',
            };


            return (
                <FormControl>
                    {this.renderCheckboxLabel()}
                    <Box {...props}>
                        <Pressable flexDirection="row" alignItems="center" onPress={this.handleToggle}>
                            {/* <Check {...checkboxProps}>{this.renderCheckboxDescription()}</Check> */}
                            <Icon {...checkboxProps}  />
                            {this.renderCheckboxDescription()}
                        </Pressable>
                    </Box>
                </FormControl>
            );
        }
    }

    return WithColorMode(Checkbox);
};


const Checkbox = factory(NBCheckbox);
export { factory as checkboxFactory };
export default Checkbox;
export { Checkbox };



export const CheckboxGroup = React.memo(
    React.forwardRef(function CheckboxGroup({ label, isInvalid, ...props }, ref) {
        const [spaceProps, notSpaceProps] = extractSpacingProps(props);
        const [flexProps, radioProps] = extractFlexProps(notSpaceProps);

        return (
            <FormControl {...spaceProps} {...flexProps} ref={ref}>
                {label && <FormControl.Label label={label} color={isInvalid ? "danger.900" : undefined} />}
                <NBCheckbox.Group {...radioProps} flexDirection="row" />
            </FormControl>
        );
    })
);

